import type { SvgProps } from 'react-native-svg';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface MapPinFilledIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const MapPinFilledIcon = ({
  size = 24,
  color = 'iconPrimary',
  ...props
}: MapPinFilledIconProps) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg {...props} width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23.5C12 23.5 22 15.6049 22 10.2308C22 4.85661 17.5228 0.5 12 0.5C6.47715 0.5 2 4.85661 2 10.2308C2 15.6049 12 23.5 12 23.5ZM12.0002 12.8851C13.5065 12.8851 14.7275 11.6969 14.7275 10.2312C14.7275 8.76553 13.5065 7.57736 12.0002 7.57736C10.494 7.57736 9.27295 8.76553 9.27295 10.2312C9.27295 11.6969 10.494 12.8851 12.0002 12.8851Z"
        fill={colors[color]}
      />
    </Svg>
  );
};
